<div
        class="d-flex align-items-center justify-content-between"
        [ngClass]="customCssClass"
>
    <text-typography [ngClass]="customTextClass">{{ title }}</text-typography>
    <span [ngClass]="color" [class]="!customIconClass ? applyStyle(style) : customIconClass">{{ type }}</span>
    <span [ngClass]="color + ' ' + customDescriptionClass" class="text-body-m">{{ description }}</span>
    <legend-typography>{{ legend }}</legend-typography>
</div>
